import React from 'react'
import { Card, CardContent, CardHeader, Fade, Typography, withStyles } from '@material-ui/core'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
import { makePath } from '../../../lib'
import { SettingsContext } from '../../../Parts/Settings'
import { Link } from 'react-router-dom'
import PersonIcon from '@material-ui/icons/Person'

const stylesGroupUsersCard = (theme) => ({
  root: {
    marginBottom: theme.spacing.unit * 2,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))',
    gridGap: `${theme.spacing.unit}px`,
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[100]
  },
  cardHeaderAction: {
    margin: 'auto',
  },
  cardContent: {
    height: 200,
    overflowY: 'scroll',
    boxSizing: 'border-box',
  },
  userBox: {
    textDecoration: 'none'
  },
  userCount: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '0.75rem',
    color: theme.palette.grey[500]
  },
  personIcon: {
    marginRight: theme.spacing.unit / 2,
    fontSize: '1rem'
  },
  avatar: {
    width: theme.spacing.unit * 5,
    height: theme.spacing.unit * 5,
    margin: `0 auto ${theme.spacing.unit / 2}px auto`
  },
  name: {
    color: theme.palette.grey[700],
    marginBottom: theme.spacing.unit,
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }
})

function GroupUsersCard(props) {
  var groupUsers
  const { classes } = props

  const gameContext = useContext(GameContext)
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  groupUsers = gameContext.getGroupUsers()

  return (
    <Fade in={Boolean(groupUsers.length > 0)}>
      <Card className={classes.root}>
        <CardHeader
          className={classes.cardHeader}
          subheader={'User'}
          action={(
            <div className={classes.userCount}>
              <PersonIcon className={classes.personIcon} color='inherit'/>
              <Typography color='inherit'>{groupUsers.length}</Typography>
            </div>
          )}
          classes={{
            action: classes.cardHeaderAction
          }}
        >
        </CardHeader>
        <CardContent className={classes.cardContent}>
          <div className={classes.grid}>
            {groupUsers.map(user => {
              let name = user.userName ? user.userName : user.displayName ? user.displayName : ''
              return user.userName ? (
                <Link
                  className={classes.userBox}
                  key={user.userName}
                  to={makePath(`/user/${user.userName}`, language)}
                  target={'_blank'}
                >
                  <CustomAvatar
                    className={classes.avatar}
                    alt={user.displayName}
                    name={user.displayName}
                    src={user.avatarPhotoURL}
                  />
                  <Typography className={classes.name} align='center'>{name}</Typography>
                </Link>
              ) : (
                <div
                  className={classes.userBox}
                  key={user.displayName}
                >
                  <CustomAvatar
                    className={classes.avatar}
                    alt={user.displayName}
                    name={user.displayName}
                    src={user.avatarPhotoURL}
                  />
                  <Typography className={classes.name} align='center'>{name}</Typography>
                </div>
              )
            })}
          </div>
        </CardContent>
      </Card>
    </Fade>
  )
}

export default withStyles(stylesGroupUsersCard, { withTheme: true })(GroupUsersCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GroupUsersCard.js